import axiosClient from 'api';
import { PaymentType } from 'types/paymentTypes';

export class PaymentTypeApi {
  static getPaymentTypes() {
    return axiosClient.get('payment_type');
  }

  static updatePaymentType({ name, _id }: PaymentType) {
    return axiosClient.put<PaymentType>('payment_type', { _id, name });
  }
}
